export const firstNames = [
  'Chloe',
  'Jacob',
  'Emily',
  'Michael',
  'Lauren',
  'Aaron',
  'Emma',
  'Shawn',
  'Aaliyah',
  'Daniel',
  'Jasmine',
  'David',
  'Olivia',
  'Ryan',
  'Jessica',
  'James',
  'Jennifer',
  'Alex',
  'Angelina',
  'Christopher',
  'Brianna',
  'Blake',
  'Rebecca',
  'Matthew',
  'Hannah',
  'Joseph',
  'Danielle',
  'Jack',
  'Julia',
  'Alexander',
  'Lily',
  'Jordan',
  'Grace',
  'Tyler',
  'Savannah',
  'Kevin',
  'Sarah',
  'Dylan',
  'Claire',
  'Ethan',
  'Mia',
  'Anthony',
  'Ava',
  'William',
  'Amanda',
  'Joshua',
  'Ella',
  'John',
  'Charlotte',
  'Adam',
];

export const lastNames = [
  'Molina',
  'McBride',
  'Ramirez',
  'Goodman',
  'Wiggins',
  'Waller',
  'Fowler',
  'Dawson',
  'Frost',
  'Alvarez',
  'Rojas',
  'Shields',
  'Krause',
  'Mejia',
  'Morrow',
  'Meyer',
  'Burke',
  'Ali',
  'Johnston',
  'Smith',
  'Ryan',
  'Randall',
  'Pitts',
  'Harmon',
  'Soto',
  'Ortiz',
  'Cross',
  'Yu',
  'Stone',
];
